import { render, staticRenderFns } from "./hcp-tag-cell.vue?vue&type=template&id=95bcc586&scoped=true"
import script from "./hcp-tag-cell.vue?vue&type=script&lang=js"
export * from "./hcp-tag-cell.vue?vue&type=script&lang=js"
import style0 from "./hcp-tag-cell.vue?vue&type=style&index=0&id=95bcc586&lang=scss&scoped=true"
import style1 from "./hcp-tag-cell.vue?vue&type=style&index=1&id=95bcc586&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bcc586",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95bcc586')) {
      api.createRecord('95bcc586', component.options)
    } else {
      api.reload('95bcc586', component.options)
    }
    module.hot.accept("./hcp-tag-cell.vue?vue&type=template&id=95bcc586&scoped=true", function () {
      api.rerender('95bcc586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hcp-tag-cell.vue"
export default component.exports